// Providers da Aplicação
import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { TutorialProvider } from './contexts/TutorialContext';
import { TutorialModalProvider } from './contexts/TutorialModalContext';
import { TrainingModalProvider } from './contexts/TrainingModalContext';
import { EditorModalProvider } from './contexts/EditorModalContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
      refetchIntervalInBackground: false,
    },
  },
});

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  return (
    <div role="alert" style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Algo deu errado</h2>
      <pre style={{ color: 'red', margin: '1rem 0' }}>{error.message}</pre>
      <button type="button" onClick={resetErrorBoundary}>
        Tentar novamente
      </button>
    </div>
  );
}

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <TutorialProvider>
              <TutorialModalProvider>
                <TrainingModalProvider>
                  <EditorModalProvider>
                    {children}
                  </EditorModalProvider>
                </TrainingModalProvider>
              </TutorialModalProvider>
            </TutorialProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default AppProviders;
